import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PreviewPDF from "./previewPDF";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";

const ButtonHelper = ({
  actionReportButon = false,
  reportButons = false,
  actionAddButon = false,
  addButon = true,
  children = false,
  pdfButton = true,
  excelButton = true,
  childrenExport = [],
  importButtons = false,
  actionImportButton1 = false,
  title = 'Exportar',
  isDownloadingReport = false,
}) => {
  const [reportDrodown, setReportDrodown] = useState(false);
  const [importDrodown, setImportDrodown] = useState(false);

  return (
    <Row>
      <div className="col-sm-6 ms-auto float-end">
        {addButon && (
          <button
            className="btn btn-sm btn-primary float-end ms-2"
            onClick={() => actionAddButon()}
          >
            <i className="fas fa-solid fa-plus"></i> Agregar
          </button>
        )}

        {reportButons && (
          <Dropdown
            className="float-end"
            isOpen={reportDrodown}
            toggle={() => setReportDrodown(!reportDrodown)}
          >
            <DropdownToggle
              tag="button"
              className="btn btn-secondary btn-sm w-100"
            >
              {isDownloadingReport ? (
                <>
                  <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i> {title}{" "}
                  <i className="mdi mdi-chevron-down" />
                </>
              ) : (
                <>
                  <i className="fa fa-file-export"></i> {title}{" "}
                  <i className="mdi mdi-chevron-down" />
                </>
              )}
            </DropdownToggle>
            <DropdownMenu>
              {excelButton && (
                <DropdownItem to="#" onClick={() => actionReportButon(1)}>
                  <i className="fa fa-file-excel"></i> Excel
                </DropdownItem>
              )}
              {pdfButton && (
                <DropdownItem to="#" onClick={() => actionReportButon(2)}>
                  <i className="fa fa-file-pdf"></i> PDF
                </DropdownItem>
              )}
              {childrenExport && Array.isArray(childrenExport) == false ? childrenExport : ""}
            </DropdownMenu>
          </Dropdown>
        )}

        {importButtons && (
          <Dropdown
            className="float-end me-2"
            isOpen={importDrodown}
            toggle={() => setImportDrodown(!importDrodown)}
          >
            <DropdownToggle
              tag="button"
              className="btn btn-secondary btn-sm w-100"
            >
              <i className="fa fa-file-import"></i> Importar{" "}
              <i className="mdi mdi-chevron-down" />
            </DropdownToggle>
            <DropdownMenu>
              {actionImportButton1 && (
                <DropdownItem to="#" onClick={() => actionImportButton1(1)}>
                  <i className="fa fa-file-excel"></i> Excel
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>
        )}

        {children.length != undefined &&
          children.filter((child) => ({ child }))}

        {children && Array.isArray(children)
          ? children.map((pchildren, child) => {
              child;
            })
          : ""}

        {children && Array.isArray(children) == false ? children : ""}
      </div>
    </Row>
  );
};

export default ButtonHelper;
